import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, withPrefix } from "gatsby"
import Helmet from "react-helmet"
import Header from "./header"
import Footer from "./footer"
import "./layout.css"
import "./resolucion_xiaomi.css"
import "./theme-dark.css"
import "./blog.css"
import Carousel from "./carousel"
import Accesibilidad from "./accesibilidad"
// import Blog from "../../../personas/blogs/index"
// import Blog from "./blogs"
// import Noticia from "../pages/personas/noticias/index"

const Layout = ({ children, site }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  let projects = data.SiteTitleQuery

  return (
    <>
      <Helmet>
        <link
          href="https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css"
          rel="stylesheet"
        ></link>

        <script src="https://code.jquery.com/jquery-1.12.4.min.js"></script>
      </Helmet>

      <Accesibilidad />
      <Header site={site} />

      <div style={{ margin: `2em auto 0 auto` }} className="text-gray-700">
        <main className="mitexto">
          {children}
          <br></br>
          <br></br>
          <br></br>
          <br></br>

          {/* {loadBlog && <Blog />} */}
          {/* {<Noticia />} */}
        </main>
      </div>
      <Footer site={site} />
      <Carousel />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  site: PropTypes.node.isRequired,
}

export default Layout
